var BaseView = require('../../components/accordion-list/content');
var UploadListMixin = require('../../components/mixins/upload-list');

module.exports = Backbone.mixin(BaseView.extend({
  apiCall: 'photo/imported',
  limit: 50,

  initialize: function (options) {
    _.bindAll(this, 'beforeSubmitEvent', 'deleteOverlayCallback');

    this.$uploadButton = options.$uploadButton;
    this.type = options.type;

    BaseView.prototype.initialize.call(this);
    UploadListMixin.initialize.call(this);

    this.refreshView = _.debounce(_.bind(function () {
      INKIVE.Modal.loader(this.$el.find('.antiscroll-inner'));
      this.masonryReload();

      this.from -= (this.limit * 2);
      this.from = this.from < 0 ? 0 : this.from;
      _.delay(_.bind(this.initDataLoading, this), 3000);
    }, this), 2000);
  },

  getParams: function () {
    var params = {
      id: INKIVE.C.BOOK.id,
      from: this.from,
      limit: this.limit
    };

    this.from += this.limit;

    return params;
  },

  getImageData: function (item) {
    return { version: _.clone(item['image']) };
  },

  initializeUpload: function () {
    var $container = this.$uploadButton.parent();

    $container.fineUploaderS3(this.getUploaderOptions($container))
      .on('progress', this.progressEvent)
      .on('error', this.errorEvent)
      .on('cancel', this.cancelEvent)
      .on('complete', this.completeEvent)
      .on('validate', (event) => this.validateEvent.call(this, event))
      .on('submitted', _.bind(function () {
        var advice = require('../../../../utils/advice');
        var fileName = $container.find('input').val();
        var extension = fileName.substring(fileName.lastIndexOf('.') + 1);

        this.submittedEvent.apply(this, arguments);

        _.contains(['pdf', 'psd'], extension) && advice.show('imported-results');
      }, this));

    $container.on('click', this.beforeSubmitEvent);
    this.setFileUploadButton();
  },

  setFileUploadButton: function () {
    var $container = this.$uploadButton.parent();
    var $dragDropBtn = $container.find('.drag-drop-file');
    var $input = $container.find('input');

    $input.css('margin', $dragDropBtn.css('margin')).css('top', 0).show();
  },

  beforeSubmitEvent: function (event) {
    var $target = $(event.target);
    var triggerUpload = $target.closest('.button.enabled').length;

    triggerUpload && $target.closest('.add').find('input').trigger('click');
  },

  complete: function (id, data) {
    var view = this.views[id];
    view.cancel();

    INKIVE.Helpers.afterRendering(_.bind(function () {
      view.remove();
      this.refreshView();
    }, this));
  },

  addDeleteOverlay: function ($element) {
    var $overlay = $('<div class="overlay">' +
        '<ul class="options">' +
            '<li data-placement="bottom" data-type="delete" data-popover="tooltip" data-original-title="' +
              INKIVE.TranslateHelper.translate('popupmenu.tooltip.remove') + '">' +
            '<i class="desygner-icon-delete"></i>' +
          '</li>' +
        '</ul>' +
      '</div>'
    );

    $overlay.find('[data-type=delete]').off('click').on('click',
      _.partial(this.tool.removeImportedElement, _.partial(this.deleteOverlayCallback, $element)));
    $element.after($overlay);
  },

  deleteOverlayCallback: function ($element) {
    var deferred = $.Deferred();
    var projectId = INKIVE.C.BOOK.id;

    INKIVE.Helpers.api('photo/remove', 'POST', {
      id: projectId || INKIVE.C.BOOK.id,
      key: $element.data('id'),
      type: this.type
    }, function (result, status) {
      status && deferred.resolve(result);
      status || deferred.reject(result);
    });

    return deferred.promise();
  }
}), UploadListMixin);
